import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ProfileProvider } from "../context/ProfileContext";
import { getRole, getToken } from "../utils/auth-token-utils/cookie";

const ConsumerProtectedRoute: React.FC = () => {
  const token = getToken();
  const role = getRole();
  if (!token || role !== "Participant") {
    return <Navigate to="/" />;
  }
  return (
    <ProfileProvider>
      <Outlet />
    </ProfileProvider>
  );
};

export default ConsumerProtectedRoute;
